export class ArrayUtils {

  static isEmpty(input: any[]): boolean {
    return (input?.length || 0) === 0;
  }

}
